var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-date-picker", {
    attrs: {
      format: _vm.format,
      type: _vm.type,
      "value-format": _vm.valueFormat,
      "start-placeholder": _vm.startPlaceholder,
      "end-placeholder": _vm.endPlaceholder,
      "default-time": ["12:00:00"],
    },
    on: { change: _vm.handleTimesChange },
    model: {
      value: _vm.span,
      callback: function ($$v) {
        _vm.span = $$v
      },
      expression: "span",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }